import React from "react";
import { Table, List, Space, Row, Col, Typography } from "antd";
const { Title, Text, Link } = Typography;

export default function ({ name, value, previousValue }) {
    return <List.Item key={name}>
        <Typography.Text>{name}:</Typography.Text> <Text strong type="secondary">{String(value) || "<<empty>>"} (New Value)</Text>{previousValue !== undefined ? <Text type="secondary">, {String(previousValue)  || "<<empty>>"} (Old Value)</Text> : <></>}
    </List.Item>
}